import postgreApiService from "./apiService";
import { RPC_DASHBOARD_ENDPOINTS } from "../endpoints";
import { getStoredUsername } from "../../utils/user";

const normalizeRecentPost = (item) => ({
    id: String(item?.Id || item?.id || ""),
    title: item?.Title || item?.title || "",
    thumbnail: item?.Thumbnail || item?.thumbnail || item?.Preview || item?.preview || "/assets/images/dashboard/D1.png",
    date: item?.Date || item?.date || "",
    type: item?.Type || item?.type || "",
});

export const getDashboardSummary = async () => {
    const p_username = getStoredUsername();
    const response = await postgreApiService.post(RPC_DASHBOARD_ENDPOINTS.SUMMARY, { p_username });
    const data = response?.data || {};
    const payload = data?.Data || data?.data || data;
    const recentPostsRaw =
        payload?.RecentPosts || payload?.recentPosts || payload?.recent_posts || [];

    return {
        ordersCount: payload?.OrdersCount ?? payload?.ordersCount ?? payload?.orders_count ?? 0,
        ordersMax: payload?.OrdersMax ?? payload?.ordersMax ?? payload?.orders_max ?? 14,
        latestOrderDate: payload?.LatestOrderDate ?? payload?.latestOrderDate ?? payload?.latest_order_date ?? null,
        orderFrequency: payload?.OrderFrequency ?? payload?.orderFrequency ?? payload?.order_frequency ?? null,
        isFirstOrderPreApproved: payload?.IsFirstOrderPreApproved ?? payload?.isFirstOrderPreApproved ?? true,
        giftsCount: payload?.GiftsCount ?? payload?.giftsCount ?? payload?.gifts_count ?? 0,
        giftsMax: payload?.GiftsMax ?? payload?.giftsMax ?? payload?.gifts_max ?? 12,
        contentCount: payload?.ContentCount ?? payload?.contentCount ?? payload?.content_count ?? 0,
        recentPosts: Array.isArray(recentPostsRaw) ? recentPostsRaw.map(normalizeRecentPost) : [],
    };
};
